import React, { useState } from "react";
import { dashboardIcon } from "../../assets/img";

function Properties({ isDataAllCard }) {
  const styles = {
    label: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "13px",
      lineHeight: "18px",
      color: "#A7A7A7",
      margin: 0,
    },
    value: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "15px",
      lineHeight: "20px",
      color: "#222227",
      margin: 0,
    },
  };

  const rearranged = isDataAllCard?.properties?.by_category?.filter(
    (item) => item.name !== "Service"
  );

  const service = isDataAllCard?.properties?.by_category?.find(
    (item) => item.name === "Service"
  );

  if (rearranged && service) rearranged.push(service);

  return (
    <>
      <div
        style={{
          padding: 12,
          width: "100%",
          background: "#FFFFFF",
          boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
          height: "auto",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 16,
          }}
        >
          <p
            style={{
              fontWeight: "700",
              fontSize: "15px",
              lineHeight: "20px",
              color: "#222227",
              margin: 0,
            }}
          >
            Properties
          </p>
        </div>

        {/* Top Two Cards */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 10,
            marginTop: "12px",
          }}
        >
          {/* Total Properties */}
          <div
            style={{
              border: "1px solid #EEEEEE",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "16px",
              padding: "12px 16px",
              width: "48%",
            }}
          >
            <div>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "400",
                  color: "#9ca3af",
                  margin: 0,
                }}
              >
                Total Properties
              </p>
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#000",
                  margin: "3px 0 0 0",
                }}
              >
                {(isDataAllCard?.properties?.total_properties || 0).toFixed(2)}
              </p>
            </div>

            <div style={{ width: "24px", height: "24px" }}>
              <img
                src={dashboardIcon}
                alt=""
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>

          {/* Total Rooms */}
          <div
            style={{
              border: "1px solid #EEEEEE",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "16px",
              padding: "12px 16px",
              width: "48%",
            }}
          >
            <div>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "400",
                  color: "#9ca3af",
                  margin: 0,
                }}
              >
                Total Rooms
              </p>
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#000",
                  margin: "3px 0 0 0",
                }}
              >
                {(isDataAllCard?.properties?.total_rooms || 0).toFixed(2)}
              </p>
            </div>

            <div style={{ width: "24px", height: "24px" }}>
              <img
                src={dashboardIcon}
                alt=""
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
        </div>

        {/* Total Breakdown */}
        <p
          style={{
            margin: "12px 0 6px 0",
            fontWeight: "700",
            fontSize: "15px",
            color: "#222227",
          }}
        >
          Total
        </p>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: 6,
          }}
        >
          {rearranged?.map((ele, i) => (
            <div
              key={i}
              style={{
                background: "#F5F5F5",
                padding: "8px",
                width: ele?.name === "Service" ? "100%" : "48%",
                borderRadius: "8px",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "8px",
              }}
            >
              <p style={styles.label}>
                {ele?.name === "Service" ? "Service Apartments" : ele?.name}
              </p>
              <p style={styles.value}>{(ele?.total || 0).toFixed(2)}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Properties;
